package io.horion.auth.api.models

sealed class Endpoint(val path: String) {
    data object Login: Endpoint(path = "/login")
    data object Authorize: Endpoint(path = "/authorize")
    data object Register: Endpoint(path = "/register")
    data object Verify: Endpoint(path = "/verify")
    data object Confirm: Endpoint(path = "/confirm")
    data object RefreshToken: Endpoint(path = "/refresh")
    data object ResetPassword: Endpoint(path = "/reset-password")
    data object ForgotPassword: Endpoint(path = "/forgot-password")
    data object Logout: Endpoint(path = "/logout")
    data object LogoutLocal: Endpoint(path = "/logout-local")
    data object CheckSession: Endpoint(path = "/check-session")
    data object SwitchAccount: Endpoint(path = "/select-account")
    object UserCreate: Endpoint(path = "/user")
    object UserUpdate: Endpoint(path = "/user")
    object UserDelete: Endpoint(path = "/user")
    object UserRead: Endpoint(path = "/user")

    //2fa
    data object DoubleFaSend: Endpoint(path = "/2fa/send-otp")
    data object DoubleFaVerify: Endpoint(path = "/2fa/verify-enable")
    data object DoubleFaDisable: Endpoint(path = "/2fa/disable")
}
